const generic = {
  registerSuccessfully: 'Register successfully :)',
  loginSuccessfully: 'Login successfully :)',
  copied: 'Copied',
} as const;

export default generic;
